import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5984f51c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "label-link" }
const _hoisted_2 = ["href"]
const _hoisted_3 = {
  key: 0,
  class: "info-text small-text"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AttensiLabel = _resolveComponent("AttensiLabel")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_AttensiLabel, { "label-id": _ctx.label }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.label), 1)
      ]),
      _: 1
    }, 8, ["label-id"]),
    _createElementVNode("a", {
      class: "anchor",
      target: "_blank",
      href: _ctx.url
    }, _toDisplayString(_ctx.url), 9, _hoisted_2),
    (_ctx.infoText)
      ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_ctx.infoText), 1))
      : _createCommentVNode("", true)
  ]))
}